import { ArrowUpRight } from "lucide-react";

export const Footer = ({ onNavigate }) => (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-[#0A1B3F] text-white">
        <div className="pointer-events-none absolute -bottom-48 left-1/3 h-[420px] w-[420px] rounded-full bg-[#1E3A8A] opacity-60 blur-[140px]" />
        <div className="relative z-10 mx-auto max-w-7xl px-6 pb-10 pt-20 lg:px-10 lg:pt-28">
            <button
                data-testid="footer-wordmark"
                onClick={() => onNavigate("#top")}
                className="group flex items-start gap-3 text-left"
                aria-label="EML Synergy — back to top"
            >
                <span className="font-display text-[13vw] font-bold leading-none tracking-tight lg:text-[9rem]">
                    EML Synergy
                </span>
                <ArrowUpRight className="mt-3 h-8 w-8 shrink-0 text-[#7FD8C4] transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 lg:mt-6 lg:h-12 lg:w-12" />
            </button>
            <div className="mt-14 flex flex-col gap-6 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
                <p className="text-sm text-slate-400">© 2026 EML Synergy. Engineering culture.</p>
                <div className="flex flex-wrap items-center gap-8 text-sm font-medium text-slate-300">
                    <button
                        data-testid="footer-link-platform"
                        onClick={() => onNavigate("#platform")}
                        className="transition-colors duration-300 hover:text-white"
                    >
                        Platform
                    </button>
                    <button
                        data-testid="footer-link-approach"
                        onClick={() => onNavigate("#approach")}
                        className="transition-colors duration-300 hover:text-white"
                    >
                        Approach
                    </button>
                    <a
                        data-testid="footer-email-link"
                        href="mailto:training@emlsynergy.com"
                        className="transition-colors duration-300 hover:text-white"
                    >
                        training@emlsynergy.com
                    </a>
                </div>
            </div>
        </div>
    </footer>
);
